module.exports = __webpack_public_path__ + "img/social-app.a476d164.png";